import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import BuildIcon from "@mui/icons-material/Build";
import AssignmentIcon from "@mui/icons-material/Assignment";
import List from "@mui/material/List";

export default function SideBar({ toggleChange }) {
  return (
    <List component="nav">
      <React.Fragment>
        <ListItemButton onClick={() => toggleChange(0)}>
          <ListItemIcon>
            <StickyNote2Icon />
          </ListItemIcon>
          <ListItemText primary="Agendar compra" />
        </ListItemButton>
        {""}
        <ListItemButton onClick={() => toggleChange(1)}>
          <ListItemIcon>
            <BuildIcon />
          </ListItemIcon>
          <ListItemText primary="Información" />
        </ListItemButton>
        {""}
      </React.Fragment>
    </List>
  );
}

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Saved reports
    </ListSubheader>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItemButton>
  </React.Fragment>
);
